import { render, staticRenderFns } from "./ProductTagChantier.vue?vue&type=template&id=e94f4dd4&scoped=true&"
import script from "./ProductTagChantier.vue?vue&type=script&lang=js&"
export * from "./ProductTagChantier.vue?vue&type=script&lang=js&"
import style0 from "./ProductTagChantier.vue?vue&type=style&index=0&id=e94f4dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94f4dd4",
  null
  
)

component.options.__file = "ProductTagChantier.vue"
export default component.exports